import { buildActivityLogDetailRows } from "./activityLogDetail";

export const RCO_ACTIVITY_STEPS = [
  {
    id: 1,
    label: "Document Submission",
    slaDays: 1,
    aliases: ["Documents Uploading", "Application Submitted"],
  },
  { id: 2, label: "Document Verification", slaDays: 1 },
  {
    id: 3,
    label: "RCO Fee Approval",
    slaDays: 1,
    aliases: ["RCO Fee Voucher Approval"],
  },
  {
    id: 4,
    label: "RCO Fee Submission",
    slaDays: 30,
    aliases: ["RCO Fee Voucher Submission"],
  },
  {
    id: 5,
    label: "RCO Fee Verification",
    slaDays: 1,
    aliases: ["RCO Fee Payment Verification"],
  },
  { id: 6, label: "Field Survey & Cost Estimation", slaDays: 1 },
  { id: 7, label: "DN Approval", slaDays: 1 },
  { id: 8, label: "DN Submission", slaDays: 30 },
  { id: 9, label: "DN Payment Verification", slaDays: 1 },
  { id: 10, label: "Meter Installation", slaDays: 1 },
  { id: 11, label: "Forward to RO", slaDays: 1 },
  { id: 12, label: "Ready for Billing", slaDays: 1 },
];

export {
  formatStepDuration,
  formatSlaLabel,
  buildActivityLogDetailRows,
} from "./activityLogDetail";

export function buildRcoActivityLogDetailRows(
  historyItems = [],
  currentStatus = {},
  formatDateFn,
) {
  return buildActivityLogDetailRows(historyItems, currentStatus, formatDateFn, {
    steps: RCO_ACTIVITY_STEPS,
    stepNameField: "reConProgStatusName",
    totalExcludeStepLabels: [
      "RCO Fee Submission",
      "RCO Fee Voucher Submission",
      "DN Submission",
    ],
  });
}
